module.exports = __webpack_public_path__ + "static/2-Qoins-Image-391d5aef13fb052f295f4bb131a481e7.png";